// src/components/Navbar.js (update the navItems array)
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaBars, FaTachometerAlt, FaChartLine, FaBell, FaCog, FaSignOutAlt, FaTimes, FaMoon, FaSun, FaRobot } from 'react-icons/fa';
import { toggleTheme, setActiveSection } from '../redux/slices/uiSlice';
import { auth } from '../firebase/config';
import toast from 'react-hot-toast';
import Logo from './Logo';

const Navbar = () => {
  const dispatch = useDispatch();
  const { theme, activeSection } = useSelector((state) => state.ui);
  const { user } = useSelector((state) => state.auth);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);

  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: <FaTachometerAlt /> },
    { id: 'trading', label: 'Trading Bot', icon: <FaRobot /> },
    { id: 'monitors', label: 'Monitors', icon: <FaChartLine /> },
    { id: 'signals', label: 'Signal History', icon: <FaBell /> },
    { id: 'settings', label: 'Settings', icon: <FaCog /> },
  ];

  const handleNavClick = (sectionId) => {
    dispatch(setActiveSection(sectionId));
    setIsMenuOpen(false);
  };

  const handleLogout = async () => {
    setIsMenuOpen(false);
    setShowUserMenu(false);
    try {
      await auth.signOut();
      toast.success('Logged out successfully');
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Logout failed');
    }
  };

  return (
    <>
      {/* Mobile Navbar */}
      <nav className="mobile-navbar">
        <div className="mobile-navbar-left">
          <button className="mobile-menu-btn" onClick={() => setIsMenuOpen(true)}>
            <FaBars />
          </button>
          <div className="mobile-logo">
            <Logo size="small" />
          </div>
        </div>
        <div className="mobile-navbar-right">
          <button className="mobile-theme-toggle" onClick={() => dispatch(toggleTheme())}>
            {theme === 'light' ? <FaMoon /> : <FaSun />}
          </button>
          <div className="mobile-user-menu">
            <div className="mobile-user-avatar" onClick={() => setShowUserMenu(!showUserMenu)}>
              {user?.photoURL ? (
                <img src={user.photoURL} alt="avatar" className="mobile-avatar-image" />
              ) : (
                user?.displayName?.charAt(0).toUpperCase() || user?.email?.charAt(0).toUpperCase() || 'U'
              )}
            </div>
            {showUserMenu && (
              <div className="mobile-user-dropdown">
                <div className="mobile-user-info">
                  <div className="mobile-user-name">{user?.displayName || 'Trader'}</div>
                  <div className="mobile-user-email">{user?.email}</div>
                </div>
                <div className="mobile-dropdown-item logout" onClick={handleLogout}>
                  <FaSignOutAlt /> Logout
                </div>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* Mobile Sidebar Menu (Drawer) */}
      <div className={`mobile-drawer-overlay ${isMenuOpen ? 'active' : ''}`} onClick={() => setIsMenuOpen(false)} />
      <div className={`mobile-drawer ${isMenuOpen ? 'active' : ''}`}>
        <div className="mobile-drawer-header">
          <div className="mobile-drawer-logo">
            <Logo size="medium" />
          </div>
          <button className="mobile-drawer-close" onClick={() => setIsMenuOpen(false)}>
            <FaTimes />
          </button>
        </div>
        <div className="mobile-drawer-nav">
          {navItems.map(item => (
            <div
              key={item.id}
              className={`mobile-drawer-nav-item ${activeSection === item.id ? 'active' : ''}`}
              onClick={() => handleNavClick(item.id)}
            >
              {item.icon}
              <span>{item.label}</span>
            </div>
          ))}
        </div>
        <div className="mobile-drawer-footer">
          <div className="mobile-drawer-user">
            <div className="mobile-drawer-user-avatar">
              {user?.photoURL ? (
                <img src={user.photoURL} alt="avatar" />
              ) : (
                user?.displayName?.charAt(0).toUpperCase() || user?.email?.charAt(0).toUpperCase() || 'U'
              )}
            </div>
            <div className="mobile-drawer-user-info">
              <div className="mobile-drawer-user-name">{user?.displayName || 'Trader'}</div>
              <div className="mobile-drawer-user-email">{user?.email}</div>
            </div>
          </div>
          <button className="mobile-drawer-logout" onClick={handleLogout}>
            <FaSignOutAlt /> Logout
          </button>
        </div>
      </div>
    </>
  );
};

export default Navbar;